import { watchlistCompliance } from './api'
import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'

import actionTypes from './action-types'

export default function* saga() {
  yield takeLatestApiCall(actionTypes.ENTITIES_FETCH_BEGIN, watchlistCompliance)
}
